import {REHYDRATE}  from 'redux-persist';
import moment from 'moment';

const commodities = [
  {
    label: 'Select a Commodity',
    value: '-1',
  },
  {
    label: 'Corn',
    value: 'Corn',
  },
  {
    label: 'Milo',
    value: 'Milo',
  },
  {
    label: 'Soybean',
    value: 'Soybean',
  },
  {
    label: 'Soybean Meal',
    value: 'Soybean Meal',
  },
  {
    label: 'Wheat',
    value: 'Wheat',
  },
];

const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const generateMonthsDropDownList = () => {
  var months = [];
  months.push({
    label: 'Select a Month',
    value: '-1',
  });
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear().toString();
  for (let i = currentMonth; i < 12; ++i) {
    months.push({
      label: monthNames[i] + ' ' + currentYear,
      value: currentYear + '-' + ((i + 1) < 10 ? ('0' + (i + 1).toString()) : (i + 1).toString()) + '-01 00:00:00',
    })
  }
  const nextYear = (currentDate.getFullYear() + 1).toString();
  for (let i = 0; i < 12; ++i) {
    months.push({
      label: monthNames[i] + ' ' + nextYear,
      value: nextYear + '-' + ((i + 1) < 10 ? ('0' + (i + 1).toString()) : (i + 1).toString()) + '-01 00:00:00',
    })
  }
  return months;
}

const initialState = {
  defaultLocationId: null,
  defaultPurchaseContractCommodity: null,
  defaultPurchaseContractContractType: null,
  locations: [],
  locationsDropDownListDataSource: [],
  commoditiesDropDownListDataSource: [],
  monthDropDownListDataSource: [],
  selectedLocation: {},
  selectedCommodity: '',
  selectedMonth: '',
  showAllLocations: false,
  fetchingLocations: false,
  cashBidsModalIsVisible: false,
  cashBidLocationNearByHistory: null,
  fetchingCashBidLocationNearByHistory: false,
  historicalNearByCommoditiesDropDownListDataSource: [],
  historicalNearByCommodity: {},
  historicalNearByStartDate: new moment().subtract(1, 'months').toDate(),
  historicalNearByEndDate: new moment().toDate(),
  purchaseContractModalIsVisible: false,
  purchaseContractModalActiveTabIndex: 0,
  purchaseContractType: 'Priced',
  purchaseContractCashBid: null,
  purchaseContractLocation: null,
  purchaseContractFutures: null,
  purchaseContractNumberOfBushels: 0,
  purchaseContractSettleGrain: false,
  purchaseContractSettleGrainPaymentType: 'ACH',
  purchaseContractComments: '',
  purchaseContractAgreeToTerms: false,
  purchaseContractSignature: '',
  savingPurchaseContract: false,
  purchaseContractSuccessModalIsVisible: false,
  newPurchaseContractNumber: null,
  purchaseContractInvalidTimeSpanModalIsVisible: false,
  purchaseContractInvalidBushelsModalIsVisible: false,
  purchaseContractNoBidsModalIsVisible: false,
  isMakeOfferInterface: false,
  offerCashPrice: 0,
  offerExpirationDate: new moment().toDate(),
  offerCreationSuccess: false,
  fetchingOffers: false,
  offers: [],
  cancelOfferModalIsVisible: false,
  cancellingOffer: false,
  offerIdToCancel: null,
  htaFees: [],
  purchaseContractHTAFee: 0.00,
  purchaseContractPrice: 0.00,
  purchaseContractApplyToExistingContract: false,
  purchaseContractExistingContractNumber: '',
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        return {
          ...state,
          ...action.payload.cashBids,
          defaultLocationId: null,
          defaultPurchaseContractCommodity: null,
          defaultPurchaseContractContractType: null,
          locations: [],
          locationsDropDownListDataSource: [],
          commoditiesDropDownListDataSource: commodities,
          monthDropDownListDataSource: generateMonthsDropDownList(),
          selectedLocation: {},
          selectedCommodity: '',
          selectedMonth: '',
          showAllLocations: false,
          fetchingLocations: false,
          cashBidsModalIsVisible: false,
          cashBidLocationNearByHistory: null,
          fetchingCashBidLocationNearByHistory: false,
          historicalNearByCommoditiesDropDownListDataSource: [],
          historicalNearByCommodity: {},
          historicalNearByStartDate: new moment().subtract(1, 'months').toDate(),
          historicalNearByEndDate: new moment().toDate(),
          purchaseContractModalIsVisible: false,
          purchaseContractModalActiveTabIndex: 0,
          purchaseContractType: 'Priced',
          purchaseContractCashBid: null,
          purchaseContractLocation: null,
          purchaseContractFutures: null,
          purchaseContractNumberOfBushels: 0,
          purchaseContractSettleGrain: false,
          purchaseContractSettleGrainPaymentType: 'ACH',
          purchaseContractComments: '',
          purchaseContractAgreeToTerms: false,
          purchaseContractSignature: '',
          savingPurchaseContract: false,
          purchaseContractSuccessModalIsVisible: false,
          newPurchaseContractNumber: null,
          purchaseContractInvalidTimeSpanModalIsVisible: false,
          purchaseContractInvalidBushelsModalIsVisible: false,
  purchaseContractNoBidsModalIsVisible: false,
          isMakeOfferInterface: false,
          offerCashPrice: 0,
          offerExpirationDate: null,
          offerCreationSuccess: false,
          fetchingOffers: false,
          offers: [],
          cancelOfferModalIsVisible: false,
          cancellingOffer: false,
          offerIdToCancel: null,
          htaFees: [],
          purchaseContractHTAFee: 0.00,
          purchaseContractPrice: 0.00,
          purchaseContractApplyToExistingContract: false,
          purchaseContractExistingContractNumber: '',
        };
      }
      return state;

    case 'INIT_CASH_BIDS':
      return {
        ...state,
        locations: [],
        locationsDropDownListDataSource: [],
        selectedLocation: {},
        selectedCommodity: '',
        selectedMonth: '',
        showAllLocations: false,
        fetchingOffers: false,
        offers: [],
        defaultPurchaseContractCommodity: null,
        defaultPurchaseContractContractType: null,
      };

    case 'SET_CASH_BIDS_DEFAULT_LOCATION_ID':
      return {
        ...state,
        defaultLocationId: action.locationId,
      };

    case 'SET_PURCHASE_CONTRACT_MODAL_DEFAULTS':
      return {
        ...state,
        defaultPurchaseContractCommodity: action.commodity,
        defaultPurchaseContractContractType: action.contractType,
      };
      
    case 'USER_REQUESTED_FETCH_CASH_BID_LOCATIONS':
      return {
        ...state,
        fetchingLocations: true,
        locations: [],
        locationsDropDownListDataSource: [],
        selectedLocation: {},
      };

    case 'FETCHED_CASH_BID_LOCATIONS':
      var locationsDropDownListDataSource = ['Select a Location'];
      action.locations.forEach((location) => {
        locationsDropDownListDataSource.push({
          label: location.locationName,
          value: location.locationId,
        });
      });
      return {
        ...state,
        locations: action.locations,
        locationsDropDownListDataSource: locationsDropDownListDataSource,
        fetchingLocations: false,
      };

    case 'FETCH_CASH_BID_LOCATIONS_FAILED':
      return {
        ...state,
        fetchingLocations: false,
      };

    case 'USER_SELECTED_CASH_BID_LOCATION':
      var historicalNearByCommoditiesDropDownListDataSource = [];
      action.location.bids.forEach(bid => {
        historicalNearByCommoditiesDropDownListDataSource.push({
          label: bid.commodity,
          value: JSON.stringify({
            basisRollingSymbol: bid.basisRollingSymbol,
            cashPriceRollingSymbol: bid.cashPriceRollingSymbol,
          }),
        });
      });
      return {
        ...state,
        selectedLocation: action.location,
        historicalNearByCommodity: JSON.parse(historicalNearByCommoditiesDropDownListDataSource[0].value),
        historicalNearByCommoditiesDropDownListDataSource: historicalNearByCommoditiesDropDownListDataSource,
      };

    case 'USER_SELECTED_CASH_BID_COMMODITY':
      return {
        ...state,
        selectedCommodity: action.commodity,
      };

    case 'USER_SELECTED_CASH_BID_MONTH':
      return {
        ...state,
        selectedMonth: action.month,
      };

    case 'TOGGLE_SHOW_ALL_CASH_BID_LOCATIONS':
      return {
        ...state,
        showAllLocations: !state.showAllLocations,
      };

    case 'USER_RESET_CASH_BID_FILTERS':
      return {
        ...state,
        selectedCommodity: '',
        selectedMonth: '',
      };

    case 'SHOW_CASH_BID_MODAL':
      return {
        ...state,
        cashBidsModalIsVisible: true,
      };

    case 'HIDE_CASH_BID_MODAL':
      return {
        ...state,
        cashBidsModalIsVisible: false,
      };

    case 'USER_SELECTED_CASHBID_LOCATION_NEAR_BY_HISTORICAL_COMMODITY':
      return {
        ...state,
        historicalNearByCommodity: JSON.parse(action.historicalNearByCommodity),
      };

    case 'USER_SELECTED_CASHBID_LOCATION_NEAR_BY_HISTORICAL_START_DATE':
      return {
        ...state,
        historicalNearByStartDate: action.historicalNearByStartDate,
      };

    case 'USER_SELECTED_CASHBID_LOCATION_NEAR_BY_HISTORICAL_END_DATE':
      return {
        ...state,
        historicalNearByEndDate: action.historicalNearByEndDate,
      };

    case 'USER_REQUESTED_FETCH_CASH_BID_LOCATION_NEAR_BY_HISTORY':
      return {
        ...state,
        fetchingCashBidLocationNearByHistory: true,
      };

    case 'FETCHED_CASH_BID_LOCATION_NEAR_BY_HISTORY':
      return {
        ...state,
        cashBidLocationNearByHistory: action.history,
        fetchingCashBidLocationNearByHistory: false,
      };

    case 'FETCH_CASH_BID_LOCATION_NEAR_BY_HISTORY_FAILED':
      return {
        ...state,
        fetchingCashBidLocationNearByHistory: false,
      };

    case 'SHOW_PURCHASE_CONTRACT_MODAL':
      return {
        ...state,
        purchaseContractModalIsVisible: true,
        purchaseContractModalActiveTabIndex: 0,
        purchaseContractType: 'Priced',
        purchaseContractCashBid: action.cashBid,
        purchaseContractLocation: action.location,
        purchaseContractFutures: action.futures,
        purchaseContractNumberOfBushels: 0,
        purchaseContractSettleGrain: false,
        purchaseContractSettleGrainPaymentType: 'ACH',
        purchaseContractComments: '',
        purchaseContractAgreeToTerms: false,
        purchaseContractSignature: '',
        savingPurchaseContract: false,
        purchaseContractSuccessModalIsVisible: false,
        newPurchaseContractNumber: null,
        isMakeOfferInterface: action.isMakeOfferInterface,
        offerCashPrice: action.cashBid.cashprice,
        offerExpirationDate: action.cashBid.delivery_end,
        offerCreationSuccess: false,
        purchaseContractHTAFee: 0.00,
        purchaseContractPrice: 0.00,
        purchaseContractApplyToExistingContract: false,
        purchaseContractExistingContractNumber: '',
      };

    case 'HIDE_PURCHASE_CONTRACT_MODAL':
      return {
        ...state,
        purchaseContractModalIsVisible: false,
      };

    case 'USER_CANCELLED_PURCHASE_CONTRACT':
      return {
        ...state,
        purchaseContractModalIsVisible: false,
      };

    case 'SET_PURCHASE_CONTRACT_MODAL_ACTIVE_INDEX':
      return {
        ...state,
        purchaseContractModalActiveTabIndex: action.index,
      };

     case 'FETCHED_HTA_FEES':
      return {
        ...state,
        htaFees: action.htaFees,
      };

    case 'SET_PURCHASE_CONTRACT_TYPE':
      return {
        ...state,
        purchaseContractType: action.contractType,
      };

    case 'SET_PURCHASE_CONTRACT_HTA_FEE_AND_PRICE':
      var purchaseContractHTAFee = 0.00;
      var purchaseContractPrice = 0.00;
      if (action.monthCount === 0) {
        purchaseContractHTAFee = action.htaFee.currentFuturesMonthFee;
        purchaseContractPrice = ((Number(action.futuresPrice) / 100) - action.htaFee.currentFuturesMonthFee).toFixed(2);
      }
      else if (action.monthCount >= 1 && action.monthCount <= 11) {
        purchaseContractHTAFee = action.htaFee._1to11FuturesMonthFee;
        purchaseContractPrice = ((Number(action.futuresPrice) / 100) - action.htaFee._1to11FuturesMonthFee).toFixed(2);
      }
      else if (action.monthCount >= 12 && action.monthCount <= 17) {
        purchaseContractHTAFee = action.htaFee._12to17FuturesMonthFee;
        purchaseContractPrice = ((Number(action.futuresPrice) / 100) - action.htaFee._12to17FuturesMonthFee).toFixed(2);
      }
      else {
        purchaseContractHTAFee = action.htaFee.upperFuturesMonthFee;
        purchaseContractPrice = ((Number(action.futuresPrice) / 100) - action.htaFee.upperFuturesMonthFee).toFixed(2);
      }
      return {
        ...state,
        purchaseContractHTAFee: purchaseContractHTAFee,
        purchaseContractPrice: purchaseContractPrice,
      };

    case 'SET_PURCHASE_CONTRACT_NUMBER_OF_BUSHELS':
      return {
        ...state,
        purchaseContractNumberOfBushels: action.numberOfBushels,
      }

    case 'SET_PURCHASE_CONTRACT_SETTLE_GRAIN':
      return {
        ...state,
        purchaseContractSettleGrain: action.settleGrain,
      };

    case 'SET_PURCHASE_CONTRACT_SETTLE_GRAIN_PAYMENT_TYPE':
      return {
        ...state,
        purchaseContractSettleGrainPaymentType: action.paymentType,
      };

    case 'SET_PURCHASE_CONTRACT_APPLY_TO_EXISTING_CONTRACT':
      return {
        ...state,
        purchaseContractApplyToExistingContract: action.apply,
        purchaseContractExistingContractNumber: action.apply === false ? '' : state.purchaseContractExistingContractNumber,
      };

    case 'SET_PURCHASE_CONTRACT_EXISTING_CONTRACT_NUMBER':
      return {
        ...state,
        purchaseContractExistingContractNumber: action.contractNumber,
      };
    
    case 'SET_PURCHASE_CONTRACT_COMMENTS':
      return {
        ...state,
        purchaseContractComments: action.comments,
      };

    case 'SET_PURCHASE_CONTRACT_AGREE_TO_TERMS':
      return {
        ...state,
        purchaseContractAgreeToTerms: action.agreeToTerms,
      };

    case 'SET_PURCHASE_CONTRACT_SIGNATURE':
      return {
        ...state,
        purchaseContractSignature: action.signature,
      };

    case 'SAVE_PURCHASE_CONTRACT_STARTED':
      return {
        ...state,
        savingPurchaseContract: true,
      };

    case 'SAVED_PURCHASE_CONTRACT':
      return {
        ...state,
        savingPurchaseContract: false,
        newPurchaseContractNumber: action.result.success === true ? action.result.purchaseContractNumber : null,
        purchaseContractSuccessModalIsVisible: true,
        purchaseContractModalIsVisible: false,
      };

    case 'SAVE_PURCHASE_CONTRACT_FAILED':
      return {
        ...state,
        savingPurchaseContract: false,
      };

    case 'HIDE_PURCHASE_CONTRACT_SUCCESS_MODAL':
      return {
        ...state,
        purchaseContractSuccessModalIsVisible: false,
      };

    case 'SHOW_PURCHASE_CONTRACT_INVALID_TIME_SPAN_MODAL':
      return {
        ...state,
        purchaseContractInvalidTimeSpanModalIsVisible: true,
      };

    case 'HIDE_PURCHASE_CONTRACT_INVALID_TIME_SPAN_MODAL':
      return {
        ...state,
        purchaseContractInvalidTimeSpanModalIsVisible: false,
      };

    case 'SHOW_PURCHASE_CONTRACT_INVALID_BUSHELS_MODAL':
      return {
        ...state,
        purchaseContractInvalidBushelsModalIsVisible: true,
      };

    case 'HIDE_PURCHASE_CONTRACT_INVALID_BUSHELS_MODAL':
      return {
        ...state,
        purchaseContractInvalidBushelsModalIsVisible: false,
      };

    case 'SHOW_PURCHASE_CONTRACT_NO_BIDS_MODAL':
      return {
        ...state,
        purchaseContractNoBidsModalIsVisible: true,
      };

    case 'HIDE_PURCHASE_CONTRACT_NO_BIDS_MODAL':
      return {
        ...state,
        purchaseContractNoBidsModalIsVisible: false,
      };

    case 'SET_OFFER_CASH_PRICE':
      return {
        ...state,
        offerCashPrice: action.cashPrice,
      };

    case 'SET_OFFER_EXPIRATION_DATE':
      return {
        ...state,
        offerExpirationDate: action.expirationDate,
      };

    case 'SAVE_OFFER_STARTED':
      return {
        ...state,
        savingPurchaseContract: true,
      };
    
    case 'SAVED_OFFER':
      return {
        ...state,
        savingPurchaseContract: false,
        purchaseContractSuccessModalIsVisible: true,
        purchaseContractModalIsVisible: false,
        offerCreationSuccess: action.success,
      };

    case 'SAVE_OFFER_FAILED':
      return {
        ...state,
        purchaseContractSuccessModalIsVisible: true,
        purchaseContractModalIsVisible: false,
        offerCreationSuccess: false,
      };

    case 'FETCH_OFFERS_STARTED':
      return {
        ...state,
        fetchingOffers: true,
        offers: [],
      };

    case 'FETCHED_OFFERS':
      return {
        ...state,
        offers: action.offers.offers,
        fetchingOffers: false,
      };

    case 'FETCH_OFFERS_FAILED':
      return {
        ...state,
        fetchingOffers: false,
      };

    case 'SHOW_CANCEL_OFFER_MODAL':
      return {
        ...state,
        cancelOfferModalIsVisible: true,
        offerIdToCancel: action.offerId,
        cancellingOffer: false,
      };

    case 'HIDE_CANCEL_OFFER_MODAL':
      return {
        ...state,
        cancelOfferModalIsVisible: false,
      };

    case 'CANCEL_OFFER_STARTED':
      return {
        ...state,
        cancellingOffer: true,
      };

    case 'CANCELLED_OFFER':
      return {
        ...state,
        cancellingOffer: false,
        cancelOfferModalIsVisible: false,
      };

    case 'CANCEL_OFFER_FAILED':
      return {
        ...state,
        cancellingOffer: false,
        cancelOfferModalIsVisible: false,
      };

    default:
      return state;
  }
}
